import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

export const getReservations = (marinaSlug, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(`/manage/${marinaSlug}/reservations${qs}`)
}

export const getReservationSelectableIds = (marinaSlug, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(`/manage/${marinaSlug}/reservations/selectable_ids${qs}`)
}

export const printReservations = async ({ marinaSlug, ids, ...params }) => {
  const response = await mutateApi({
    url: `/manage/${marinaSlug}/reservations/print`,
    method: "POST",
    data: { ids, ...params },
  })
  return response.data
}

export const exportReservations = ({ marinaSlug, ids }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/reservations/bulk_export`,
    method: "POST",
    data: { ids },
  })
}

export const cancelReservation = async (reservationId, params, slug) => {
  return mutateApi({
    url: `/manage/${slug}/reservations/${reservationId}/cancel`,
    method: "PUT",
    data: params,
  })
}
